import React from 'react';
import { Bot, Newspaper } from 'lucide-react';

export const Header: React.FC = () => {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white shadow-sm">
            <Bot className="w-6 h-6" />
          </div>
          <div>
            <h1 className="font-bold text-xl text-slate-900 leading-tight">AI新闻通俗解释</h1>
            <p className="text-xs text-blue-600 font-medium tracking-wide uppercase">AI News Agent</p>
          </div>
        </div>
        
        <div className="hidden sm:flex items-center gap-2 text-slate-500 text-sm font-medium">
          <Newspaper className="w-4 h-4" />
          <span>每日智能精粹</span>
        </div>
      </div>
    </header>
  );
};